import { ISchedule, WorkplaceRequestElement } from "@gettactic/api";
import { canScheduleOthers } from "@gettactic/helpers";
import { useAuthenticated } from "@gettactic/hooks";
import {
  SimpleTable,
  SimpleTableBody,
  SimpleTableCell,
  SimpleTableHeader,
  SimpleTableHeaderCell,
  SimpleTableRow
} from "@v2/components/ui/SimpleTable/SimpleTable";
import { useIsMobile } from "@v2/hooks/use-mobile";
import { RequestDetailsPage } from "@webV2/pages/settings/WorkplaceRequestsPage/components/RequestDetailsPage";
import { StatusDisplay } from "@webV2/pages/settings/WorkplaceRequestsPage/components/table-parts/StatusDisplay";
import { useState } from "react";
import { useWorkplaceRequestModal } from "../../../contexts/WorkplaceRequestModalContext";

export const WPRequestsPlaneTable = ({
  workplaceRequests,
  schedule,
  onRequestClick
}: {
  workplaceRequests: WorkplaceRequestElement[];
  schedule: ISchedule;
  onRequestClick?: (request: WorkplaceRequestElement) => void;
}) => {
  const {
    userContext: { authenticatedUser }
  } = useAuthenticated();
  const isAdmin = canScheduleOthers(authenticatedUser);
  const isMobile = useIsMobile();
  const { openModal } = useWorkplaceRequestModal();
  const [selectedRequest, setSelectedRequest] =
    useState<WorkplaceRequestElement | null>(null);

  if (isMobile) {
    return (
      <div className="my-2 w-full">
        <div className="space-y-2">
          {workplaceRequests.map((request) => (
            <div
              key={request.id}
              onClick={() => onRequestClick ? onRequestClick(request) : openModal(request)}
              className="cursor-pointer rounded-lg border border-gray-200 bg-white p-3 shadow-sm hover:bg-gray-50"
            >
              <div className="flex items-center justify-between">
                <div className="min-w-0 flex-1">
                  <div className="truncate font-medium text-gray-900 text-sm">
                    {request.title}
                  </div>
                  <div className="mt-1 text-gray-500 text-xs">
                    {request.type.name}
                  </div>
                </div>
                <div className="ml-2 flex-shrink-0">
                  <StatusDisplay
                    request={request}
                    isAdmin={false}
                    isMobile={true}
                    onStatusChange={() => {}}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
        {selectedRequest && (
          <RequestDetailsPage
            dontTouchUrl={true}
            requestId={selectedRequest.id}
            isAdmin={isAdmin}
            onRequestUpdate={(updatedRequest: WorkplaceRequestElement) => {
              setSelectedRequest(updatedRequest);
            }}
            isPageMode={false}
            initialRequest={selectedRequest}
            onClose={() => setSelectedRequest(null)}
            schedule={schedule}
          />
        )}
      </div>
    );
  }
  return (
    <div className="mt-2 w-full shadow-sm">
      <SimpleTable className={"w-full text-xs"}>
        <SimpleTableHeader>
          <SimpleTableHeaderCell>Request</SimpleTableHeaderCell>
          <SimpleTableHeaderCell>Type</SimpleTableHeaderCell>
          <SimpleTableHeaderCell>Status</SimpleTableHeaderCell>
        </SimpleTableHeader>
        <SimpleTableBody className="shadow-none">
          {workplaceRequests.map((request) => (
            <SimpleTableRow
              onClick={() => setSelectedRequest(request)}
              className={"cursor-pointer bg-white hover:bg-gray-50"}
              key={request.id}
            >
              <SimpleTableCell cellInnerClassName="bg-!transparent">
                {request.title}
              </SimpleTableCell>
              <SimpleTableCell cellInnerClassName="bg-!transparent">
                {request.type.name}
              </SimpleTableCell>
              <SimpleTableCell cellInnerClassName="bg-!transparent">
                <StatusDisplay
                  request={request}
                  isAdmin={false}
                  isMobile={false}
                  onStatusChange={() => {}}
                />
              </SimpleTableCell>
            </SimpleTableRow>
          ))}
        </SimpleTableBody>
      </SimpleTable>
      {selectedRequest && (
        <RequestDetailsPage
          dontTouchUrl={true}
          requestId={selectedRequest.id}
          isAdmin={isAdmin}
          onRequestUpdate={(updatedRequest: WorkplaceRequestElement) => {
            setSelectedRequest(updatedRequest);
          }}
          isPageMode={false}
          initialRequest={selectedRequest}
          onClose={() => setSelectedRequest(null)}
          schedule={schedule}
        />
      )}
    </div>
  );
};
